import { COLOR_VALUES } from "shared/config/colors";
import HStack from "shared/components/layout/stack/HStack";
import Photo from "shared/components/data-display/media/Photo";
import VStack from "shared/components/layout/stack/VStack";
import styled from "styled-components";

export const Wrapper = styled(VStack)``;

export const StyledContactCard = styled(HStack)`
    background: ${COLOR_VALUES.White};
    border: 1px solid ${COLOR_VALUES.Gray_6};
    border-radius: 4px;
    padding: 16px;
`;

export const StyledContactCardContent = styled(VStack)`
    gap: 12px;
    min-width: 0;
`;

export const StyledPhoto = styled(Photo)`
    width: 44px;
    height: 44px;
`;

export const CopyContainer = styled(HStack)`
    white-space: nowrap;

    .textMassage {
        visibility: hidden;
    }
    &:hover {
        .textMassage {
            visibility: visible;
        }
    }
`;
